import * as S from "./style";
import axiosInstance from "../../services/axiosInstance";
//Components
import TopActionBar from "../../components/TopActionBar";
import TitleDefault from "../../components/Title/TitleDefault";
import Footer from "../../components/Footer";
import { useEffect, useState } from "react";
import PopMenu from "../../components/PopMenuTable";
import Details from "../../components/Modals/Accessory/Details";
import Update from "../../components/Modals/Accessory/Update";
import Delete from "../../components/Modals/Delete";
import Loading from "../../components/Loading";
import NoData from "../../components/NoData";
import Auth401 from "../../components/Error/Auth";
import Erro429 from "../../components/Error/Erro429";
//Hooks
import useLoading from "../../hooks/useLoading";
import { useMultipleModal } from "../../hooks/useMultipleModal";
import { useCheckbox } from "../../hooks/useCheckbox";
//Interface
import { IData } from "Interfaces/IAccessory";
import { IPage } from "Interfaces/IPage";
//Icons
import { FiMoreVertical } from "react-icons/fi";
import { Trash, List, PencilSimple } from "@phosphor-icons/react";
//Utils
import { CurrencyFormat } from "utils/CurrencyFormat";

export default function Accessory() {
  const [data, setData] = useState<IData[]>([]);
  const [openModalOptId, setOpenModalOptId] = useState<number | null>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setCurrentPage] = useState<IPage>({
    id: 0,
    last_page: 0,
    current_page: 0,
    total: 0,
  });
  const { isOpenModal, toggleModalVisibility, assignRef } = useMultipleModal();
  const { isLoading, startLoading, stopLoading } = useLoading();
  const { selectedIds, toggleCheckbox, setSelectedIds, CleanSelectIds } =
    useCheckbox();
  const [selectAll, setSelectAll] = useState(false);
  // Para um array de objetos
  const [tags, setTags] = useState<Array<{
    barcode: string;
    code: string;
    price: string;
  }>>([]);

  const listHeaderTable = [
    "#",
    "Código",
    "Nome",
    "Quantidade",
    "Preço",
    "Ações"
  ];

  const menuItemsPop = [
    { icon: <List size={16} />, title: "Detalhes", isActive: false, path: "details" },
    { icon: <PencilSimple size={16} />, title: "Editar", isActive: false, path: "update" },
    { icon: <Trash size={16} />, title: "Excluir", isActive: true, path: "delete" },
  ];

  const [filters, setFilters] = useState({
    tamanho: "",
    haste: "",
    ponte: "",
    cor: "",
    grife: "",
    material: "",
  });

  const handleMenuClick = (path: string) => {
    toggleModalVisibility(path);
  };

  const clickPopTable = (id: number) => {
    setOpenModalOptId(id);
    toggleModalVisibility("menu");
  };

  const handleSearchChange = (term: string) => {
    setSearchTerm(term);
    fetchData();
  };

  const fetchData = async (pageNumber = 1, perPage = 10) => {
    startLoading();
    try {
      let url = `/accessory?page=${pageNumber}&per_page=${perPage}`;
      if (searchTerm.trim()) {
        url += `&search=${searchTerm}`;
      }
      const response = await axiosInstance.get(url);
      setData(response.data.data);
      setCurrentPage(response.data);
    } catch (error: any) {
      if (error.status === 401) {
        toggleModalVisibility('auth');
      } else if (error.status === 429) {
        toggleModalVisibility('request429');
      }
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    const debounceFetch = setTimeout(() => {
      fetchData();
    }, 300);

    return () => clearTimeout(debounceFetch);
  }, [searchTerm]);

  const handleSelectAll = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const isChecked = event.target.checked;
    setSelectAll(isChecked);

    if (isChecked) {
      const newSelectedIds = new Set(data.map((item) => item.id));
      setSelectedIds(newSelectedIds);

      // Adiciona todos os itens às tags se ainda não estiverem presentes
      setTags(prevTags => {
        // Criar um mapa dos códigos existentes para evitar duplicatas
        const existingCodes = new Set(prevTags.map(tag => tag.code));

        // Filtrar apenas os itens que ainda não existem nas tags
        const newItems = data.filter(item => !existingCodes.has(item.barcode))
          .map(item => ({
            barcode: item.barcode || '',
            code: item.name || '',
            price: item.price || ''
          }));

        // Retorne a combinação do array anterior com os novos itens
        return [...prevTags, ...newItems];
      });

    } else {
      CleanSelectIds();
      setTags([]);
    }
  };

  const handleCheckChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    id: number,
    barcode: string,
    code: string,
    price: string,
  ) => {
    const isChecked = event.target.checked;
    toggleCheckbox(id);
    setTags(prevTags => {
      if (isChecked) {
        return [
          ...prevTags,
          {
            barcode,
            code,
            price
          }
        ];
      } else {
        // Remove
        return prevTags.filter(tag => tag.barcode !== barcode);
      }
    });

  };

  const handleDeleteResponse = (status: number) => {
    if (status === 200) {
      setSelectedIds(new Set());
      setSelectAll(false);
    }
  };

  if (isOpenModal("auth")) {
    return (
      <Auth401 isOpen={isOpenModal("auth")} />
    )
  } else if (isOpenModal("request429")) {
    return (
      <Erro429 />
    )
  }

  return (
    <S.Container>
      <TitleDefault
        filterSearch={handleSearchChange}
        modalKey="accessory"
        title="Registro de Acessórios"
        subtitle="Gerencie os acessórios do sistema"
        placeholderSearch="Nome do acessório"
        fetchData={fetchData}
        titleButton="Novo Acessório"
      />
      {isLoading ? (
        <Loading />
      ) : (
        <S.Content>
          <S.ContaintableButton>
            <S.ContentButton>
              {selectedIds.length > 0 && (
                <TopActionBar
                  idSelecteds={selectedIds}
                  typeProduct="acessory"
                  urlFilter={filters}
                  nameDeleteAll="accessory-delete-multiple"
                  fetchData={fetchData}
                  handleDeleteResponse={handleDeleteResponse}
                  isPromo={false}
                  isTag={true}
                  itemsTag={tags}
                />
              )}
            </S.ContentButton>

            <S.Table>
              <S.THead>
                <tr>
                  <th>
                    <S.CheckBox
                      type="checkbox"
                      id="deleteAll"
                      checked={selectAll}
                      onChange={(e) => handleSelectAll(e)}
                    />
                  </th>
                  {listHeaderTable.map((header, index) => (
                    <th key={index}>{header}</th>
                  ))}
                </tr>
              </S.THead>

              <S.TBody>
                {
                  data.length > 0 ? (
                    data.map((val, index) => (
                      <tr key={index}>
                        <td>
                          <S.CheckBox
                            onChange={(e) => handleCheckChange(
                              e,
                              val.id,
                              val.barcode,
                              val.name,
                              val.price
                            )}
                            type="checkbox"
                            id={val.barcode}
                            name={val.barcode}
                            checked={selectedIds.includes(val.id)}
                          />
                        </td>
                        <td>{index + 1 || "-"}</td>
                        <td>{val.barcode || "-"}</td>
                        <td>{val.name || "-"}</td>
                        <td>{val.amount || "-"}</td>
                        <td>{CurrencyFormat(parseFloat(val.price) || 0) || "-"}</td>
                        <S.TdPopMenu>
                          <S.ContentPopMenu>
                            <S.ButtonTable onClick={() => clickPopTable(val.id)}>
                              <FiMoreVertical />
                            </S.ButtonTable>
                          </S.ContentPopMenu>
                          {isOpenModal("menu") && openModalOptId === val.id && (
                            <div ref={(ref) => assignRef("menu", ref)}>
                              <PopMenu menuItems={menuItemsPop} onClickTable={handleMenuClick} />
                            </div>
                          )}
                        </S.TdPopMenu>
                      </tr>
                    ))
                  ) : <NoData />
                }
              </S.TBody>
            </S.Table>
          </S.ContaintableButton>
        </S.Content>
      )}

      {page && (
        <Footer
          fetchData={fetchData}
          currentPage={page.current_page}
          lastPage={page.last_page}
          allPerPage={page.total}
        />
      )}

      <Update
        isOpenModalUpdate={isOpenModal("update")}
        setModalClose={() => toggleModalVisibility("update")}
        selectedUrlId={openModalOptId}
        updateList={fetchData}
      />

      <Details
        isOpenModal={isOpenModal("details")}
        setModalClose={() => toggleModalVisibility("details")}
        selectedUrlId={openModalOptId}
      />

      <Delete
        updateList={fetchData}
        endpoint="accessory"
        selectedProductId={openModalOptId}
        isOpenModal={isOpenModal("delete")}
        setModalClose={() => toggleModalVisibility("delete")}
      />
    </S.Container>
  );
}
